import React, { type ReactNode } from 'react';
import { isServerEnvironment } from '../../common/utils/is-server-environment/isServerEnvironment.tsx';
import { useRouterStore } from '../router-store/index.tsx';
import type { RouterActionsType, RouterState } from '../router-store/types.tsx';

export type RouterSubscriberProps = {
	children: (state: RouterState, actions: RouterActionsType) => ReactNode;
};

export const RouterSubscriber = ({ children }: RouterSubscriberProps): React.JSX.Element => {
	const [state, { listen, ...actions }] = useRouterStore();

	if (!state.unlisten && !isServerEnvironment()) {
		listen();
	}

	return <>{children(state, actions)}</>;
};
